// Native disclosures retain click/touch/keyboard behaviour; add familiar dismissal.
document.addEventListener('click', (event) => {
  document.querySelectorAll('.nw-nav-collections[open]').forEach((menu) => {
    if (event.target instanceof Node && !menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.nw-nav-collections[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary')?.focus();
  });
});
